<template>
    <section id="opens" class="inline large">
        <div class="home-hotlead bg-l1 fixed fixed-max-sm">
            <div class="grid inline gap-4 sm-gap-3 grid-cols-1 sm-grid-cols-5 md-grid-cols-2">
                <b class="col-span-1 sm-col-span-2 md-col-span-1">
                    Get connected today to one of our top real estate experts.
                    <br/><br/>
                    Or call us at <a href="tel:(844) 417-0593" class="link text-main" style="white-space: nowrap;">(844) 417-0593</a></b>
                <div class="col-span-1 sm-col-span-3 md-col-span-1">
                    <mvtHotleadForm v-if="hotleadOpt" class="middle" :options="hotleadOpt" />
                </div>
            </div>
        </div>
    </section>
</template>

<script src="./home-hotlead.js"></script>

<style lang="scss">
    @use "./home-hotlead.scss" as *;
</style>